import { render, staticRenderFns } from "./addOldDialog.vue?vue&type=template&id=8fbfda46&"
import script from "./addOldDialog.vue?vue&type=script&lang=ts&"
export * from "./addOldDialog.vue?vue&type=script&lang=ts&"
import style0 from "./addOldDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports